export const SCRIPT_BLOCKED_TYPE = 'text/plain'
export const SCRIPT_TYPE = 'text/javascript'
